<template>
	<div>
		<div @click="goToSystem" style="cursor: pointer;">
			{{data.systemName}}
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: {}
		}
	},
	methods: {
		goToSystem() {
            this.$router.push({
                name: "settingsGeneral",
                params: {
                    systemName: this.data.systemName,
                    systemId: this.data.id,
                },
            });
        }
	},
}
</script>


// WEBPACK FOOTER //
// src/components/Systems/ClickableSystemName.vue